export const harvestData = [
  {
    harvestId: '001',
    name: 'Crop harvesting',
    city: 'vehari',
    qty: '2323',
    price: '250',
  },
  {
    harvestId: '001',
    name: 'Crop harvesting',
    city: 'vehari',
    qty: '2323',
    price: '250',
  },
  {
    harvestId: '001',
    name: 'Crop harvesting',
    city: 'vehari',
    qty: '2323',
    price: '250',
  },
  {
    harvestId: '001',
    name: 'Crop harvesting',
    city: 'vehari',
    qty: '2323',
    price: '250',
  },
  {
    harvestId: '001',
    name: 'Crop harvesting',
    city: 'vehari',
    qty: '2323',
    price: '250',
  },
  {
    harvestId: '001',
    name: 'Crop harvesting',
    city: 'vehari',
    qty: '2323',
    price: '250',
  },
  ]

export const harvestHeadCells = [
  {id: "harvestId", numeric: false, disablePadding: true, label: "harvest Id"},
  {id: "name", numeric: true, disablePadding: false, label: "Name"},
  {id: "purchasedFrom", numeric: false, disablePadding: false, label: "purchased From"},
  {id: "price", numeric: false, disablePadding: false, label: "price"},
  {id: "qty", numeric: false, disablePadding: false, label: "qty",},
  {id: "action", numeric: true, disablePadding: false, label: "actions"},
];
